/**
 * Serverin real xəta mesajını çıxarır.
 *
 * Əvvəl panel bütün nasazlıqları eyni «Failed to save post» kimi göstərirdi —
 * səbəb (təkrar slug, boş sahə, silinmiş kateqoriya) heç vaxt görünmürdü.
 * NestJS validasiya xətalarını massiv kimi qaytarır, ona görə hər iki hal işlənir.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const message = (error as any)?.response?.data?.message;

  if (Array.isArray(message) && message.length > 0) return message.join('\n');
  if (typeof message === 'string' && message.trim()) return message;

  return fallback;
}
